"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchLoupeIcon20Light = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.SearchLoupeIcon20Light = forwardRef_1.forwardRef('SearchLoupeIcon20Light', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.504 2.256a7.248 7.248 0 1 0 4.759 12.714l3.375 3.376a.5.5 0 0 0 .708-.707l-3.376-3.376A7.248 7.248 0 0 0 9.504 2.256ZM3.256 9.504a6.248 6.248 0 1 1 12.495 0 6.248 6.248 0 0 1-12.495 0Z" })));
});
